import { breakpoints, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const DiscoverSetsText = styled.div`
  flex: 1;
`;

export const Title = styled.div`
  ${theme.typography.labelLarge}
  text-align: center;
  @media (min-width: ${breakpoints.md}) {
    ${theme.typography.titleLarge}
  }
`;

export const SliderWrapper = styled.div<{ centerSlider: boolean }>`
  margin: 1.25rem 0 0.25rem;

  [data-testid='phone-slider'] {
    padding: 0 1.25rem 2rem;

    justify-content: ${({ centerSlider }) =>
      centerSlider ? 'center' : 'flex-start'};
  }

  @media (min-width: ${breakpoints.md}) {
    margin: 2.25rem 0 2rem;

    [data-testid='desktop-slider'] > div {
      justify-content: ${({ centerSlider }) =>
        centerSlider ? 'center' : 'flex-start'};
    }
  }
`;
